import { communityInfo } from '@/mocks/home';

export default function CommunitySection() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
          {communityInfo.title}
        </h2>
        <p className="text-foreground-500 text-sm md:text-base max-w-2xl mx-auto mb-10">
          {communityInfo.description}
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 mb-10">
          {communityInfo.features.map((feature) => (
            <div
              key={feature.title}
              className="bg-background-50 border border-background-200/70 rounded-xl p-6 text-center hover:border-accent-200/60 transition-all duration-300"
            >
              <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-accent-100">
                <i className={`${feature.icon} text-accent-600 text-xl`} />
              </div>
              <h3 className="text-sm font-semibold text-foreground-800 mb-2">{feature.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://twitter.com/mizuno_asahi"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="inline-flex items-center gap-2 px-6 py-3 bg-foreground-950 hover:bg-foreground-800 text-background-50 font-medium rounded-full transition-all duration-300 whitespace-nowrap text-sm"
          >
            <i className="ri-twitter-x-line" />
            关注 Twitter
          </a>
          <a
            href="https://instagram.com/mizuno_asahi"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="inline-flex items-center gap-2 px-6 py-3 bg-accent-500 hover:bg-accent-600 text-background-50 font-medium rounded-full transition-all duration-300 whitespace-nowrap text-sm"
          >
            <i className="ri-instagram-line" />
            关注 Instagram
          </a>
        </div>
      </div>
    </section>
  );
}